exports.version = "2.2.8"


//////////////////
// WEBPACK FOOTER
// ../app_shared/~/apollo-client/version.js
// module id = 569
// module chunks = 1